import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';
import { StudentGuard } from './core/auth/student.guard';
import { LoginComponent } from './features/auth/login/login.component';
import { HomeComponent } from './features/home/home.component';
import { StudentAccountLockedComponent } from './features/student/components/student-account-locked.component';

// Define the main application routes
const routes: Routes = [
  // Public route: Home (landing page with all sections)
/*  {
    path: '',
    component: HomeComponent
  },*/
  // Redirect separate public pages to home with anchor scrolling
  {
    path: 'about',
    redirectTo: '/#about'
  },
  {
    path: 'teachers',
    redirectTo: '/#teachers'
  },
  {
    path: 'content',
    redirectTo: '/#content'
  },
  {
    path: 'offers',
    redirectTo: '/#offers'
  },
  {
    path: 'contact',
    redirectTo: '/#contact'
  },
  // Public route: Login
  {
    path: 'login',
    component: LoginComponent
  },
  // Protected, lazy-loaded Admin area
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/admin/admin.module').then(m => m.AdminModule)
  },
  // Public route: Student account locked (no authentication required)
  {
    path: 'student/account-locked',
    component: StudentAccountLockedComponent
  },
  // Protected, lazy-loaded Student area
  {
    path: 'student',
    canActivate: [StudentGuard],
    loadChildren: () => import('./features/student/student.module').then(m => m.StudentModule)
  },
  // Fallback for unknown routes
  {
    path: '**',
    redirectTo: '/login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 100], // Account for fixed navbar (increased for better spacing)
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
